import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("fn_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function saveAuth(token, user) {
  localStorage.setItem("fn_token", token);
  localStorage.setItem("fn_user", JSON.stringify(user));
}
export function loadUser() {
  try { return JSON.parse(localStorage.getItem("fn_user") || "null"); } catch { return null; }
}
export function clearAuth() {
  localStorage.removeItem("fn_token");
  localStorage.removeItem("fn_user");
}
